
const DirectiveEntryExecutionEntryAwaitingClientReview = () => {
  return (
    <p className="text-warning text-right">
      Aguardando vistoria do cliente
    </p>
  );
}

export default DirectiveEntryExecutionEntryAwaitingClientReview;
